<template>
  <div class="overlay" v-if="show">
    <div class="overlay_inner channel_list">
      <p class="note" v-translate>Výběr profilového obrázku</p>
      <div class="scrollable_popup profile_images_popup">
        <p class="profile_images_header" v-translate>Systémové obrázky</p>
        <div class="profile_images_block profile_images_system">
          <div class="profile_images" :class="{'expanded' : isExpanded}" ref="system_images" :style="{ maxHeight: imageListHeight + 'px' }">
            <div
                v-for="image in images" @click="onClick(image.id, image.path)"
                v-bind:key="image.id"
                class="profile_image_item"
                :class="{'selected' : image.id === selected}"
            >
              <img :src="image.path" :alt="image.name"/>
            </div>
          </div>
          <p class="expand_button">
            <button v-if="showExpandButton" @click.stop.prevent="toggleExpand" class="expand_profile_images" v-translate>
              Zobrazit další
            </button>
          </p>
        </div>

        <p class="profile_images_header"><translate>Vlastní obrázky</translate> <span class="profile_images_parameters">({{ constraintText() }})</span>
        </p>
        <div class="profile_images_block profile_images_custom">
          <div v-if="messageTimers.upload.show" class="add_item_notice add_item_success" v-translate>Obrázek byl nahrán.</div>
          <div v-if="messageTimers.delete.show" class="add_item_notice add_item_success" v-translate>Obrázek byl smazán.</div>
          <div v-if="messageTimers.validation.show" class="add_item_notice add_item_failure">{{validationText}}</div>
          <div v-if="messageTimers.error.show" class="add_item_notice add_item_failure">{{errorText}}</div>
          <div class="profile_images">
            <div class="profile_image_item add_item">
              <input
                  type="file"
                  accept="image/*"
                  name="user_image"
                  id="user_image"
                  class="input_file"
                  data-multiple-caption="{count} files selected"
                  v-if="uploadReady"
                  @change="onFileChange"
                  ref="user_image"
              />
              <label for="user_image" class="add_image" title="Nahrát obrázek"><span v-translate>Nahrát obrázek</span></label>
            </div>
            <div
                v-for="image in customImages" @click="onClick(image.id, image.path)"
                v-bind:key="image.id"
                class="profile_image_item"
                :class="{'selected' : image.id === selected}"
            >
              <img :src="image.path" :alt="image.name"/>
              <a class="btn btn_action btn_delete" v-if="image.id !== selected"
                 @click.stop.prevent="deleteCustomImage(image.id)" :title="$gettext('Smazat')" v-translate>Smazat</a>
            </div>
          </div>
        </div>
      </div>
      <a @click="setShow(false)" class="btn btn_action btn_close" title="Zavřít" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>
import imageValidation from "../images/mixins/imageValidation";
import message from "../../mixins/message";

const COLLAPSED_HEIGHT = 140;
const MESSAGE_TIMEOUT = 5000;

export default {
  name: 'SelectImagePopup',
  mixins: [imageValidation, message],
  props: {
    idSelected: Number,
    idSubscriberProfile: Number,
    idSubscriber: Number,
  },
  data() {
    return {
      newImage: null,
      images: [],
      customImages: [],
      show: false,
      selected: null,
      uploadReady: true,
      type: 'profile_images',
      messageTimers: {
        upload: {show: false, timer: null},
        delete: {show: false, timer: null},
        validation: {show: false, timer: null},
        error: {show: false, timer: null},
      },
      validationText: "",
      errorText: "",
      isExpanded: false,
      showExpandButton: false,
      imageListHeight: COLLAPSED_HEIGHT,
    }
  },
  created(SubscriberProfileService, ImageService) {
    this.subscriberProfileService = SubscriberProfileService;
    this.imageService = ImageService;
    this.imageService.getConstraints()
        .then((data) => {
          this.constraints = data.image_constraints;
        });
  },
  methods: {
    recalcSystemImagesLayout() {
      this.$nextTick(() => {
        const box = this.$refs['system_images'];
        if (!box) return;

        const contentHeight = box.scrollHeight || 0;

        this.showExpandButton = contentHeight > COLLAPSED_HEIGHT;

        if (this.isExpanded) {
          this.imageListHeight = contentHeight;
        } else {
          this.imageListHeight = Math.min(contentHeight, COLLAPSED_HEIGHT);
        }
      });
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      this.recalcSystemImagesLayout();
    },
    deleteCustomImage(id) {
      this.imageService.deleteEntity(id, {id_subscriber: this.idSubscriber})
          .then(() => {
            this.setSuccessMessage();
            this.loadImages();
            this.showMessage('delete');
          })
          .catch(function (error) {
            this.errorText = error.error_message;
            this.showMessage('error');
          }.bind(this))
    },
    deleteImage() {
      for (const key in this.image_validity) {
        this.image_validity[key] = null;
      }
      this.newImage = null;
    },
    setShow(state) {
      this.show = state;
      this.selected = this.idSelected;
      if (this.show && !this.images.length) {
        this.loadImages();
      }
      if (this.show) {
        this.recalcSystemImagesLayout();
      }
    },
    loadImages() {
      this.subscriberProfileService.getImageList({
        id_subscriber_profile: this.idSubscriberProfile,
        id_subscriber: this.idSubscriber
      })
          .then(data => {
            this.images = [];
            this.customImages = [];
            data['list'].forEach(item => {
              if (item.custom) {
                this.customImages.push(item);
              } else {
                this.images.push(item);
              }
            })
            this.recalcSystemImagesLayout();
          })
    },
    onClick(id, path) {
      this.selected = id;
      this.$emit('input', id, path);
      this.setShow(false);
    },
    async onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      await this.validateImageFile(file);
      if(this.imageIsValid) {
        this.newImage = file;
        this.uploadImage();
      }else{
        this.newImage = null;
        e.target.value = '';
        this.validationText = this.$gettextInterpolate(this.$gettext('Obrázek nesplňuje požadované parametry: %{constraints}'), { constraints: this.constraintText(this.image_validity) });
        this.showMessage('validation');
      }
    },
    uploadImage() {
      const fd = new FormData();
      fd.append('uploaded_file', this.newImage);
      fd.append('type', this.type);
      fd.append('id_subscriber', this.idSubscriber);

      this.imageService.createEntity(fd)
          .then(() => {
            this.loadImages();
            this.showMessage('upload');
          })
          .catch(function (error) {
            this.errorText = error.error_message;
            this.showMessage('error');
          }.bind(this))
    },
    constraintText(imageValidation = null){
      let width = {'params': ['min_width', 'max_width'], 'value': null};
      let height = {'params': ['min_height', 'max_height'], 'value': null};
      let ratio = {'params': ['width_ratio'], 'value': null};
      let max_kb = {'params': ['max_kb'], 'value': null};
      let mime_types = {'params': ['mime_types'], 'value': null};

      if(this.constraint.hasOwnProperty('max_width') && this.constraint.hasOwnProperty('min_width')){
        width['value'] = this.$gettext('šířka') + ': ' + this.constraint.min_width + '–'+this.constraint.max_width+' px';
      }else if(this.constraint.hasOwnProperty('min_width')){
        width['value'] = this.$gettext('minimální šířka') + ': ' + this.constraint.min_width + ' px';
      }else if(this.constraint.hasOwnProperty('max_width')){
        width['value'] = this.$gettext('maximální šířka') + ': '+ this.constraint.max_width + ' px';
      }

      if(this.constraint.hasOwnProperty('max_height') && this.constraint.hasOwnProperty('min_height')){
        height['value'] = this.$gettext('výška') + ': ' + this.constraint.min_height + '–'+this.constraint.max_height+' px';
      }else if(this.constraint.hasOwnProperty('min_height')){
        height['value'] = this.$gettext('minimální výška') + ': ' + this.constraint.min_height + ' px';
      }else if(this.constraint.hasOwnProperty('max_height')){
        height['value'] = this.$gettext('maximální výška') + ': '+ this.constraint.max_height + ' px';
      }

      if(this.constraint.hasOwnProperty('width_ratio')){
        ratio['value'] = this.$gettext('poměr stran š/v') + ': ' + this.constraint.width_ratio;
      }

      if(this.constraint.hasOwnProperty('max_kb')){
        max_kb['value'] = this.$gettext('maximální velikost') + ': ' + this.constraint.max_kb + 'kB';
      }

      if(this.constraint.hasOwnProperty('mime_types') && this.constraint.mime_types.length){
        mime_types['value'] = this.$gettext('typ') + ': ' + this.constraint.mime_types.join(', ');
      }

      return [width, height, ratio, max_kb, mime_types]
          .filter(item => {
            if(imageValidation === null){
              return item.value !== null;
            }else{
              return item.params.some(param =>
                  Object.hasOwn(imageValidation, param) && !imageValidation[param]
              );

            }})
          .map(item => {
            return item.value;
          })
          .join(', ');
    },
    resetTimers(){
      Object.values(this.messageTimers).forEach(item => {
        item.show = false;
        if (item.timer) {
          clearTimeout(item.timer);
          item.timer = null;
        }
      });
    },
    showMessage(type){
      this.resetTimers();
      this.$nextTick(() => {
        this.messageTimers[type].show = true;
        this.messageTimers[type].timer = setTimeout(() => {
          this.messageTimers[type].show = false;
        }, MESSAGE_TIMEOUT);
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscriberProfile/SelectImagePopup.vue